import { useMemo } from "react";
import { DetailedUser } from "web/model/DetailedUser";
import * as Sentry from "@sentry/react";

export const useCurrentUser = () => {
    return useMemo(() => {
        const user = new DetailedUser((window as any).INIT_USER);
        Sentry.setUser({
            email: user.email,
            id: user.id,
            username: user.email,
            extra: {
                isAdmin: user.isAdmin,
                organizations: user.organizations.map(org => org.id),
            },
        });
        return user;
    }, [(window as any).INIT_USER]);
};
